import { Component, EventEmitter, Output } from '@angular/core';
import { getSmartRecoNutritionalAssessment } from '@app/pages/smart-reco/store/actions/smart-reco-recommendation.actions';
import {
  selectNutritionalAssessmentBenefitClaim,
  selectNutritionalAssessmentHasError,
  selectNutritionalAssessmentLoading,
  selectNutritionalAssessmentMacronutrients,
  selectNutritionalAssessmentOtherNutrients,
} from '@app/pages/smart-reco/store/selectors/smart-reco-nutritional-assessment.selectors';
import { NutrientType } from '@app/shared/components/nutrients-list/nutrients';
import { IconName } from '@app/shared/utils/icon/icons';
import { AppState } from '@app/store';
import { VetFacade } from '@app/store/vet';
import { Store } from '@ngrx/store';
import { nutrientInfographyMock } from './nutritional-assessment';
import { map } from 'rxjs/operators';
import { getXrayFAQLink } from '@app/shared/utils';

@Component({
  selector: 'app-nutritional-assessment',
  templateUrl: './nutritional-assessment.component.html',
  styleUrls: ['./nutritional-assessment.component.scss'],
})
export class NutritionalAssessmentComponent {
  @Output() submitted = new EventEmitter();

  public macroNutrients$ = this.store$.select(selectNutritionalAssessmentMacronutrients);
  public otherNutrients$ = this.store$.select(selectNutritionalAssessmentOtherNutrients);
  public benefitClaim$ = this.store$.select(selectNutritionalAssessmentBenefitClaim);
  public nutritionalAssessmentHasError$ = this.store$.select(selectNutritionalAssessmentHasError);
  public nutritionalAssessmentLoading$ = this.store$.select(selectNutritionalAssessmentLoading);
  public readonly IconName = IconName;
  public readonly NutrientType = NutrientType;
  public nutrientsMock = nutrientInfographyMock;

  public xrayFAQPdfUrl$ = this.vetFacade.vet$.pipe(map((vet) => getXrayFAQLink(vet.user)));

  constructor(private store$: Store<AppState>, private vetFacade: VetFacade) {}

  submitRecommendation(): void {
    this.submitted.emit();
  }

  retryGetNutritionalAssessment(): void {
    this.store$.dispatch(getSmartRecoNutritionalAssessment());
  }
}
